function getColmunsNew({ t }) {

  const inverterEvents = {
    SysM: t('box.notificationInverter.table.filter.sysm'),
    Pri: t('box.notificationInverter.table.filter.pri'),
    BtTy: t('box.notificationInverter.table.filter.btty'),
    SPHS: t('box.notificationInverter.table.filter.SPHS'),
    DerM: t('box.notificationInverter.table.filter.derm'),
    Even: t('box.notificationInverter.table.filter.even'),
    EGrid: t('box.notificationInverter.table.filter.egrid'),
  };

  const descriptions = {
    waitingmodule: t('box.notificationInverter.table.sysm.waiting_module'),
    selftestmode: t('box.notificationInverter.table.sysm.self-testmode'),
    reserved: t('box.notificationInverter.table.sysm.reserved'),
    sysfaultmodule: t('box.notificationInverter.table.sysm.sysfaultmodule'),
    flashmodule: t('box.notificationInverter.table.sysm.flashmodule'),
    gridandpvonline: t('box.notificationInverter.table.sysm.gridandpvonline'),
    gridonlineandpvoffline: t('box.notificationInverter.table.sysm.gridonlineandpvoffline'),
    gridofflineandpvonline: t('box.notificationInverter.table.sysm.gridofflineandpvonline'),
    batofflinemodemodule: t('box.notificationInverter.table.sysm.batofflinemodemodule'),
    loadfirst: t('box.notificationInverter.table.sysm.loadfirst'),
    batteryfirst: t('box.notificationInverter.table.sysm.batteryfirst'),
    gridfirst: t('box.notificationInverter.table.sysm.gridfirst'),
    leadacid: t('box.notificationInverter.table.sysm.leadacid'),
    lithiumbattery: t('box.notificationInverter.table.sysm.lithiumbattery'),
    faultbatteryok: t('box.notificationInverter.table.sysm.faultbatteryok'),
    faultbatteryfail: t('box.notificationInverter.table.sysm.faultbatteryfail'),
    faultgridok: t('box.notificationInverter.table.sysm.faultgridok'),
    faultgridfail: t('box.notificationInverter.table.sysm.faultgridfail'),
  };

  const columns = [
    {
      width: '15%',
      title: t('box.notificationInverter.table.Category'),
      dataIndex: 'typeId',
      filters: [
        {
          text: 'SysM',
          value: 'SysM',
        },
        {
          text: 'Pri',
          value: 'Pri',
        },
        {
          text: 'BtTy',
          value: 'BtTy',
        },
        {
          text: 'Even',
          value: 'Even',
        },
        {
          text: 'EGrid',
          value: 'Egrid',
        },
        // {
        //   text: 'SPHS',
        //   value: 'SPHS',
        // },
        // {
        //   text: 'DerM',
        //   value: 'DerM',
        // },
      ],
      onFilter: (value, record) => record.typeId.indexOf(value) === 0,
    },
    {
      width: '20%',
      title: t('box.notificationInverter.table.name'),
      dataIndex: 'typeId',
      render: (name) => inverterEvents[name],
    },
    {
      width: '20%',
      title: t('box.notificationInverter.table.Attribute'),
      dataIndex: 'value',
    },
    {
      width: '45%',
      title: t('box.notificationInverter.table.description'),
      dataIndex: 'description',
      render: (_, record) => {

        const findTranslation = record.value.toLowerCase()
          .split('')
          .map((letter) => ((letter === ' ' || letter === '-') ? null : letter))
          .join('');
        let auxFindTranslation = findTranslation;
        if (record.name === 'Fault Battery') auxFindTranslation = 'faultbattery'.concat(findTranslation);
        if (record.name === 'Fault Grid') auxFindTranslation = 'faultgrid'.concat(findTranslation);
        return descriptions[auxFindTranslation];

      },
    },
  ];
  return columns;

}

export default getColmunsNew;
